import * as TK from 'components/Session/Alert/StoreLockAlert/translations/locale.constants';

export const storeLockCommonLocale = {
  [TK.SL_MORE_INFO]: 'More info',
  [TK.SL_LESS_INFO]: 'Less info',
  [TK.SL_STORE_SCHEDULE]: '{{day}}: {{from}} – {{to}}',
};
